import store from "@/store.js";

const helper = {
  before(before) {
    if (before && typeof before !== "undefined") {
      before();
    }
  },
  success(response, success) {
    if (typeof success !== "undefined") {
      success(response.data);
    }
  },
  failure(error, failure) {
    if (!error) {
      return;
    }
    if (error) {
      if (typeof failure !== "undefined" && failure !== null) {
        failure(error.data);
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      if (typeof failure !== "undefined" && failure !== null) {
        failure("Wystąpił niespodziewany błąd");
      }
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error", error.message);
      if (typeof failure !== "undefined" && failure !== null) {
        failure("Wystąpił niespodziewany błąd");
      }
    }
  },
};

export default {
  get(action, params, success, failure, before) {
    if (before) {
      helper.before(before);
    }
    console.log(store.state.api.api_url + action);
    window.Vue.http
      .get(
        store.state.api.api_url + action,
        { params: params },
        {
          emulateJSON: true,
          emulateHTTP: true,
        }
      )
      .then((response) => {
        helper.success(response, success);
      })
      .catch(function (error) {
        helper.failure(error, failure);
      });
  },
  getFlex(url, params, success, failure, before, headers) {
    if (before) {
      helper.before(before);
    }
    console.log(headers);
    window.Vue.http
      .get(
        url,
        { params: params, headers: headers },
        {
          emulateJSON: true,
          emulateHTTP: true,
        }
      )
      .then((response) => {
        helper.success(response, success);
      })
      .catch(function (error) {
        helper.failure(error, failure);
      });
  },
  post(action, params, success, failure, before, h) {
    const host = window.location.host;
    const parts = host.split(".");
    let server = store.state.api.api_url;
    if (parts[0] === "lead") {
      server = "https://s1.lead-api.test.ang01.pl";
      // server = "https://api.s0.mustang.test.ang01.pl";
    }
    let headers = {
      emulateJSON: true,
      emulateHTTP: true,
    };
    if (h && typeof h !== "undefined") {
      headers["headers"] = { Authorization: `Bearer ${h}` };
    }
    helper.before(before);
    window.Vue.http
      .post(server + action, params, headers)
      .then((response) => {
        helper.success(response, success);
      })
      .catch(function (error) {
        helper.failure(error, failure);
      });
  },
  postFlex(action, params, success, failure, before, h) {
    let headers = {
      emulateJSON: true,
      emulateHTTP: true,
    };
    if (h && typeof h !== "undefined") {
      headers["headers"] = { Authorization: `Bearer ${h}` };
    }
    helper.before(before);
    window.Vue.http
      .post(action, params, headers)
      .then((response) => {
        helper.success(response, success);
      })
      .catch(function (error) {
        helper.failure(error, failure);
      });
  },
  delete(action, params, success, failure, before) {
    helper.before(before);
    window.Vue.http
      .delete(store.state.api.api_url + action, params, {
        emulateJSON: true,
        emulateHTTP: true,
      })
      .then((response) => {
        helper.success(response, success);
      })
      .catch(function (error) {
        helper.failure(error, failure);
      });
  },
};
